import { Link } from 'react-router-dom'
import { baseStateToProps, BaseView } from '../lib/base_view'
import { request } from '../lib/utils'
import { store } from '../../index'
import { ModalSearch } from './modal_search'


export class BaseBpsView extends BaseView {
  constructor(props) {
    super(props)

    this.state = {}
    this.request_progress = new Set()

    this.initMeta = this.initMeta.bind(this)
    this.savePreset = this.savePreset.bind(this)
    this.setUserPreset = this.setUserPreset.bind(this)
    this.removeUserSearch = this.removeUserSearch.bind(this)
    this.getPresetCounter = this.getPresetCounter.bind(this)
    this.getTopPanelLeftactions = this.getTopPanelLeftactions.bind(this)
  }

  get project_name() {
    return this.props.project_name
  }

  initMeta() {
    const that = this

    request({
      method: 'get',
      url: `/api/${this.project_name}/get_meta`,
      success: (data) => {
        that.waitRenderReadyLock = false
        store.dispatch({ type: `${that.project_name}_model_meta`, data })
      },
    })
  }

  savePreset(name) {
    store.dispatch({ type: `${this.project_name}_preset`, data: name })
    this.redirect_to(`/${this.project_name}`)
  }

  setUserPreset(preset) {
    this.onSearch(preset.data)
  }

  removeUserSearch(search_id) {
    const that = this
    request({
      method: 'post',
      url: `/api/${this.project_name}/delete_saved_search/${search_id}`,
      success: (data) => {
        store.dispatch({ type: `${that.project_name}_saved_search`, data })
      },
    })
  }

  getPresetCounter(preset_name) {
    // Если список не разворачивался, то пока ничего не нужно
    if (!this.state.hasPresetOpen) {
      return undefined
    }

    const that = this
    const preset_counters = this.state.preset_counters || {}
    const count = preset_counters[preset_name]

    if (count === undefined && !this.request_progress.has(preset_name)) {
      that.request_progress.add(preset_name)

      request({
        method: 'post',
        url: `/api/${that.project_name}/get_preset_counter`,
        data: {
          filter_data: that.props.search_data,
          preset: preset_name,
        },
        success: (data) => {
          that.setState((state) => {
            const preset_counters = state.preset_counters || {}
            return { preset_counters: { ...preset_counters, [preset_name]: data } }
          }, () => {
            that.request_progress.delete(preset_name)
          })
        },
        error: () => {
          that.request_progress.delete(preset_name)
        }
      })
    }

    return count
  }

  getTopPanelLeftactions() {
    let actions = []

    return actions
  }

  renderTopPanelLeftItems() {
    const that = this
    const perms = this.props.perms
    const search_presets = this.props.search_presets
    const search_form = this.props.search_form
    const list_items_count = this.props.list_items_count
    const actions = this.getTopPanelLeftactions()

    if (perms === undefined) {
      return null
    }

    const search_data = this.props.search_data
    const current_preset = this.props.search_preset
    const styleActive = { borderBottom: "2px solid rgb(40, 199, 111)", paddingBottom: "7px" }

    let preset_items = []

    search_presets && search_presets.forEach(item => {
      const preset_name = item[0]
      const preset_title = item[1]
      const preset_count = that.getPresetCounter(preset_name)

      preset_items.push(<li key={preset_name}>
        <a onClick={() => that.savePreset(preset_name)} className="dropdown-item">
          {preset_name === current_preset && <i className="ti ti-checks me-1"></i>}
          {preset_title} {preset_count !== undefined ? <span className="text-muted">- {preset_count}</span> : ""}
        </a>
      </li>)
    })

    // Разделитель между фиксированными отборами и пользовательскими
    if (preset_items.length > 0 && this.props.saved_searches.length > 0) {
      preset_items.push(<li key="header">
        <h6 className="dropdown-header">Ваши настройки поиска</h6>
      </li>)
    }

    this.props.saved_searches.forEach(item => {
      preset_items.push(<li key={item.id}>
        <a className="dropdown-item">
          <span className="d-flex align-items-center align-middle">
            <span className="flex-grow-1 align-middle me-2" onClick={() => { that.setUserPreset(item) }}>
              {item.title}
            </span>
            <span className="flex-shrink-0 d-flex align-items-center justify-content-center" onClick={() => that.removeUserSearch(item.id)}>
              <i className="ti ti-trash-x me-1 text-danger"></i>
            </span>
          </span>
        </a>
      </li>)

    })

    let presets = null;
    if (preset_items.length > 0) {
      const preset_style = current_preset ? styleActive : undefined

      presets = <span className="dropdown me-2" key="presets" style={preset_style}>
        <a className="dropdown-toggle hide-arrow" data-bs-toggle="dropdown" onClick={() => { that.setState({ hasPresetOpen: true }) }}>
          <i className="ti ti-filter me-2"></i>
          <span className="d-none d-md-inline-block">Отбор</span>
        </a>
        <ul className="dropdown-menu mt-2">
          <li key="reset">
            <a onClick={() => that.savePreset('')} className="dropdown-item">
              <i className="ti ti-trash-x me-1"></i>
              Сброс
            </a>
          </li>
          {preset_items}
        </ul>
      </span>
    }

    const search_style = Object.keys(search_data).length === 0 ? undefined : styleActive

    return [
      that.updateItems && <span className="me-2" key="refresh">
        <a onClick={(e) => { that.updateItems(that.props.list_page, true) }}>
          <i className="ti ti-refresh ti-xs me-1"></i>
          <span className="d-none d-md-inline-block">Обновить</span>
        </a>
      </span>,

      perms.includes("create") && <span className="me-2" key="create">
        <Link className="text-heading" to={`/${this.project_name}/new/`} >
          <i className="ti ti-plus ti-xs me-1"></i>
          <span className="d-none d-md-inline-block">Создать</span>
        </Link>
      </span>,

      search_form && Array.isArray(search_form) && search_form.length > 0 && <span className="me-2" key="search">
        <a data-bs-toggle="modal" data-bs-target="#modal_search" className="active" style={search_style}>
          <i className="ti ti-search ti-xs me-1"></i>
          <span className="d-none d-md-inline-block">
            Поиск {list_items_count && <span>({list_items_count})</span>}
          </span>
        </a>
      </span>,

      presets,

      actions?.length > 0 && <span className="dropdown me-2" key="actions">
        <a className="dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
          <i className="ti ti-adjustments-horizontal me-2"></i>
          <span className="d-none d-md-inline-block">Действия</span>
        </a>
        <ul className="dropdown-menu mt-2">{actions}</ul>
      </span>,
    ]
  }

  renderModals() {
    if (this.props.search_form) {
      return [<ModalSearch
        project_name={this.project_name}
        schema={this.props.search_form}
        data={this.props.search_data}
        onSearch={this.onSearch}
        choices={this.props.choices}
      />]
    }

    return []
  }
}


/**
 * Отображает состояние хранилища redux на props view проекта
 * Вначале получаем props по умолчанию и потом добавляем туда свойства для bps приложения
 */
export function stateToProps(state, project_name) {
  var props = baseStateToProps(state)
  const project_data = state[project_name] || {}

  // метаданные проекта
  props.project_name = project_name
  props.project_title = project_data.project_title
  props.table_headers = project_data.table_headers
  props.user_table_headers = project_data.user_table_headers
  props.search_form = project_data.search_form
  props.search_presets = project_data.search_presets
  props.saved_searches = project_data.saved_searches
  props.form_schema = project_data.form_schema
  props.attrs = project_data.attrs
  props.perms = project_data.perms

  // Настройка сортировки
  props.table_headers_ordered = project_data.table_headers_ordered
  props.order_attr_name = project_data.order_attr_name
  props.order_direction = project_data.order_direction

  // Данные о состоянии поиска
  props.search_data = project_data.search_data || {}
  props.search_preset = project_data.search_preset
  props.list_items_count = project_data.list_items_count

  // Элементов на текущей странице
  props.list_items = project_data.list_items
  props.list_page = project_data.list_page || 1
  props.list_count_pages = project_data.list_count_pages
  props.list_has_next_page = project_data.list_has_next_page

  props.form_group_hidden = project_data.form_group_hidden

  return props
}
